// @flow
// $FlowFixMe
import React, { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';

import styles from './Image.css';
import { quantizedPixelSize, imgixImageUrl, IMGIX_STYLE_1 } from '../../lib/imgix';

type OwnProps = {
  src: string,
  className?: string,
  width: number,
  height: number,
  alt: string,
};

const Image = ({ src, className, width, height, alt }: OwnProps) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);

  const onLoad = () => {
    setLoaded(true);
  };

  const onError = () => {
    setError(true);
  };

  useEffect(() => {
    const imgElement = imgRef.current;

    if (imgElement && imgElement.complete) {
      if (imgElement.naturalWidth === 0) {
        onError();
      } else {
        onLoad();
      }
    }
  }, [src]);

  return (
    <div className={className}>
      <img
        src={imgixImageUrl({
          path: src,
          style: IMGIX_STYLE_1,
          width: quantizedPixelSize(width),
          height: quantizedPixelSize(height),
        })}
        className={classnames(styles.image, {
          [styles.loaded]: loaded,
          [styles.error]: error,
        })}
        loading="lazy"
        decoding="async"
        alt={alt}
        draggable={false}
        ref={imgRef}
        onError={onError}
        onLoad={onLoad}
      />
    </div>
  );
};

export default Image;
